import { createTheme } from '@mui/material/styles';
const DupontShelterTheme = createTheme({
  palette: {
    primary: {
      main: '#e4001c',
    },
    secondary: {
      main: '#00a9e0',
    },
  },
  typography: {
    button: {
      fontFamily: 'Diodrum',
      //fontSize: '1rem',
      fontWeight: '100',
      letterSpacing: '0',
      lineHeight: 1.25,
    },
  },
  components: {
    MuiTouchRipple: {
      styleOverrides: {
        ripple: {
          display: 'none', // Disable the ripple effect
        },
      },
    },
  },
});

export default DupontShelterTheme;
